export const FOLDER_START_ID = 'FOLDER_';

export const FILE_TYPE = {
  FILE: 'file',
  FOLDER: 'folder',
} as const;

export const FILES_ACTION = {
  VIEW: 'view',
  DOWNLOAD: 'download',
  PREVIEW: 'preview',
};

export const FOLDER_FILE_KEY = '__placeholder__';

export const FILE_ACCESS_LEVEL = {
  READ_ONLY: 'read_only',
  READ_WRITE: 'read_write',
} as const;

export const ESIGNATURE_PAGE_MARGIN = 15;

// `/` and `\` are path separators. A name that contains one is split into
// folders on upload and inside a zip, so typed names reject both characters.
export const NAME_PATH_SEPARATOR_ERR_MSG = 'Name cannot contain / or \\';
export const PATH_SEPARATOR_REPLACEMENT = '-';
export const PATH_SEPARATOR_UPLOAD_ADJUSTED_MSG =
  'Replaced / or \\ in file names with a hyphen so they stay in this folder.';

export const containsPathSeparator = (value?: string | null) =>
  !!value && (value.includes('/') || value.includes('\\'));

export const replacePathSeparators = (value: string) =>
  value.replace(/[/\\]/g, PATH_SEPARATOR_REPLACEMENT);

export const FOLDER_VALIDATION_ERR_MSG = NAME_PATH_SEPARATOR_ERR_MSG;

// Must stay in sync with backend/lib/constants/s3.go InvalidS3PathChars
export const INVALID_S3_PATH_CHARS = ['*', '=', '|', '@', '^'] as const;

export const INVALID_S3_PATH_CHARS_ERR_MSG = `Cannot contain special characters (${INVALID_S3_PATH_CHARS.join(
  ',',
)}) in name`;

export const INVALID_S3_PATH_CHARS_UPLOAD_ERR_MSG = `Folder or file names cannot contain special characters (${INVALID_S3_PATH_CHARS.join(
  ',',
)})`;

export const IMAGE_FORMATS = ['png', 'jpg', 'jpeg', 'gif'];
